<div id="welcomeBackPopup"
class="welcome-popup {{additionalClasses}}"
>

  <div class="topBlock">
    <div class="topText">
      Welcome Back!
    </div>
    <div  id="imgDiv">
      <img src="../../../../../assets/images/welcome_back_logo.svg" loading="lazy" />
    </div>
    <div *ngIf="!isMobile && !withContinue && !multiLoan" class="botText">
      <!-- It looks like you already have an account. Please login to the iCreditWorks mobile App for account information, to view account activity, or make a payment. -->
      It looks like you already have an account. Simply<br>
      log into the mobile App and provide the information<br>
      needed to complete your loan application.
    </div>
    <div *ngIf="isMobile && !withContinue && !multiLoan" class="botText">
      It looks like you already have an account.<br>
      Simply log into the mobile App and<br>
      provide the information needed to<br>
      complete your loan application.
    </div>
    <div *ngIf="!isMobile && withContinue" class="botText">
      Please click "Continue" to view the loan options from<br> your last session on <span class="font-weight-bold">{{lassSession}}</span>.
    </div>
    <div *ngIf="isMobile && withContinue" class="botText">
      Please click "Continue" to view<br> the loan options from your last session<br> on <span class="font-weight-bold">{{lassSession}}</span>.
    </div>
    <div *ngIf="!isMobile && multiLoan" class="botText">
      It looks like you already have an account. Please login to<br>
      the iCreditWorks mobile App for account information,<br>
      to view account activity, or make a payment.
    </div>
    <div *ngIf="isMobile && multiLoan" class="botText">
      It looks like you already have an account.<br>
      Simply log into the mobile App and<br>
      provide the information needed to<br>
      complete your loan application.
    </div>
  </div>

  <div class="OKbtn btn btn-size_normal btn-primary a-self-center" (click)="close()" >{{withContinue ? 'Continue' : 'OK'}}</div>
</div>


